<template>
  <div class="flex flex-row">
    <div class="w-20 flex flex-col flex-shrink-0 items-center">
      <div class="h-12 w-12 rounded-full flex items-center justify-center shadow-md" :class="relativeBulletClasses">
        <div class="font-bold text-lg">
          <div v-if="status === 'finished'" class="text-green-500">
            <font-awesome-icon :icon="['far', 'check']" size="lg" />
          </div>
          <div v-else>
              {{ step.id }}
          </div>
        </div>
      </div>
      <div class="w-2px bg-gray-300 flex-grow" :class="relativeLineClasses" v-if="!isLast"></div>
    </div>
    <div class="flex-auto" :class="relativeContentClasses">
      <div class="text-2xl text-gray-800 flex items-center mt-2">
        <div class="text-red-500">
          <font-awesome-icon :icon="['far', step.icon]" />
        </div>
        <div class="ml-2">{{ step.name }}</div>
      </div>
      <div class="mt-2" v-if="status === 'active' || status === 'finished'">
        <slot />
      </div>
    </div>
  </div>
</template>

<script>

export default {
  name: 'workflow-step',
  props: {
    step: {
      type: Object,
      required: true
    },
    status: {
      type: String,
      required: true
    },
    isLast: {
      type: Boolean,
      default: false
    }
  },
  computed: {
    relativeBulletClasses () {
      return {
        'bg-gray-500 text-white': this.status === 'active',
        //'bg-white border-2 border-gray-400 text-gray-600': this.isFinished,
        'border-green-500 border-2 bg-green-100': this.status === 'finished'
      }
    },
    relativeLineClasses () {
      return {
        'bg-gray-500': this.status === 'finished'
      }
    },
    relativeContentClasses () {
      return {
        'border-l-8 border-gray-500 bg-gray-300 shadow-lg p-8 mb-10': this.status === 'active',
        'px-8 border-b-2 border-gray-300 pb-8 mb-8': this.status !== 'active'
      }
    }
  },
}
</script>